import AtMentionsViewState from 'mini-mentions-picker-plugin/lib/store/schema/AtMentionsViewState';
import BodyType from 'owa-service/lib/contract/BodyType';
import EditorViewState from 'mini-editor/lib/store/schema/EditorViewState';
import ItemId from 'owa-service/lib/contract/ItemId';
import ReadWriteRecipientWellViewState from 'mini-readwrite-recipient-well/lib/store/schema/ReadWriteRecipientWellViewState';
import RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import { AttachmentWellViewState } from 'mini-attachment-well-data';
import { ComposeSource } from './ComposeSource';
import { LazyAction } from 'owa-bundling';

export const enum ComposeOperation {
    New,
    Reply,
    ReplyAll,
    Forward,
    EditDraft,
    ReportError,
    ForwardCalendarEvent,
}

/**
 * TODO VSO:96515 Use composition instead of inheritance here
 * Currently using extend to support the soon-to-be legacy consumers
 * Once we migrate completely to roosterjs editor, editorViewState should ideally be a member of ComposeViewState
 */
interface ComposeViewState extends EditorViewState {
    // Message properties
    operation: ComposeOperation;
    itemId: ItemId;
    bodyType: BodyType;
    subject: string;
    referenceItemId: ItemId;
    attachmentWell: AttachmentWellViewState;
    irmData: RightsManagementLicenseDataType;

    // recipient well
    toRecipientWell: ReadWriteRecipientWellViewState;
    ccRecipientWell: ReadWriteRecipientWellViewState;
    bccRecipientWell: ReadWriteRecipientWellViewState;
    isBccWellShown: boolean;

    // UI properties
    lastSaveTimeStamp: string;
    isSending: boolean;
    isSavingSpinnerShown: boolean;
    infoBarIds: string[];
    disableAttachments: boolean;
    disableCcBccWells: boolean;
    disableDraftOperations: boolean;
    source: ComposeSource;

    // UpConvert
    quotedBody: string;
    useSmartResponse: boolean;
    isFirstLoadedQuotedBodySuccess: boolean;
    isAutoFocussed: boolean; // Property to check whether the compose operation has done the initial auto focus on toRecipientWell or on the Message Editor or not

    // Diagnostics
    lazyGenerateMiniDiagnosticsReport?: LazyAction<() => Promise<string>, any>;

    // At Mentions
    atMentionsViewState: AtMentionsViewState;
}

export default ComposeViewState;
